import { PhotoFaceInfo } from "./photoFaceSlice";
import { StudentInfo } from "../student/studentSlice";
import { UserInfo } from "../user/userSlice";

export interface FaceDetailsInfo {
  photoFace: PhotoFaceInfo;
  student?: StudentInfo;
  user?: UserInfo;
}

export const faceDisplayname = (item?: FaceDetailsInfo): string => {
    if(item == undefined) {
        return "Não identificado";
    }
    if(item.student) {
        return item.student.nickname || item.student.name;
    }
    if(item.user) {
        return item.user.name || item.user.email;
    }
    if(item.photoFace.nobody == 1) {
        return "Desconhecido";
    }
    return "Não identificado";
};
